import { render, staticRenderFns } from "./MediaCategoryAdd.vue?vue&type=template&id=399ca0b0&scoped=true"
import script from "./MediaCategoryAdd.vue?vue&type=script&lang=js"
export * from "./MediaCategoryAdd.vue?vue&type=script&lang=js"
import style0 from "./MediaCategoryAdd.vue?vue&type=style&index=0&id=399ca0b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399ca0b0",
  null
  
)

export default component.exports